module.exports = __webpack_public_path__ + "static/tiger-59f4ee4b1263ee12e2095eb8ace00f9a.jpg";